import AmioHttpService from '@/services/amio/amio-http.service'

class VariablesService extends AmioHttpService {
  async create(variable) {
    try {
      const response = await this.requestPost('/variables', variable)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, variable) {
    try {
      const response = await this.requestPatch(`/variables/${id}`, variable)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async list() {
    try {
      const response = await this.requestGet('/variables')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/variables/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async getReferences(id) {
    try {
      const response = await this.requestGet(`/variables/${id}/references`)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new VariablesService()
